
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 11","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 5.5c0 .917-3.582 5.5-8 5.5S0 6.417 0 5.5C0 4.583 3.582 0 8 0s8 4.583 8 5.5zm-4.5 0a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zM8 7.5a2 2 0 100-4 2 2 0 000 4z"}})])
          )
        }
      }
    